import { ChangeDetectionStrategy, Component, computed, inject, Input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { selectUiState } from '../../../../store/app.selectors';

import { BaseComponent } from '../../../shared/components/base/base.component';
import { uiInitialState } from '../../../shared/store/ui.reducer';
import { WebsocketService } from '../../services/websocket.service';
import { AppStateWithChat } from '../../store/chat.reducer';

@Component({
  selector: 'ngx-channels',
  templateUrl: './channels.component.html',
  styleUrls: ['./channels.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChannelsComponent extends BaseComponent {
  @Input() phoneNumber: string;

  private store = inject(Store<AppStateWithChat>);
  public WebsocketService = inject(WebsocketService);

  ui = toSignal(this.store.select(selectUiState), { initialValue: uiInitialState });
  showFilters = computed(() => this.ui().showChannelsFilters);
}
